import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import LoggingUtil from './LoggingUtil';
import LoggingEventType from '../constants/LoggingEventType';
import LoggingResultType from '../constants/LoggingResultType';
import { LOGGER_URL, LOGGER_EVENT_TYPE_URL, LOGGER_RESULT_TYPE_URL } from '../constants/loggingConstants';

var LoggingPayload = /*#__PURE__*/function () {
  function LoggingPayload(logEvent, details) {
    _classCallCheck(this, LoggingPayload);

    this.logEvent = logEvent;
    this.details = details;
  }

  _createClass(LoggingPayload, null, [{
    key: "initialize",
    value: function initialize(payload) {
      var payloadCopy = Object.assign({}, payload);

      if (!payloadCopy.eventType || !(payloadCopy.eventType in LoggingEventType)) {
        throw new Error("LogEvent doesn't contain an eventType field, please check documentation @ ".concat(LOGGER_EVENT_TYPE_URL, " for possible values"));
      }

      if (!payloadCopy.eventName) {
        throw new Error("Payload logEvent doesn't contain an eventName field, please check documentation @ ".concat(LOGGER_URL, " for further details"));
      }

      if (!payloadCopy.object) {
        throw new Error("Payload logEvent doesn't contain an object field, please check documentation @ ".concat(LOGGER_URL, " for further details"));
      }

      if (!payloadCopy.description) {
        payloadCopy.description = payloadCopy.eventName;
      }

      if (!payloadCopy.businessContext) {
        payloadCopy.businessContext = '';
      }

      if (payloadCopy.loggingResultType && !(payloadCopy.loggingResultType in LoggingResultType)) {
        throw new Error("Invalid value for LoggingResultType, please check documentation @ ".concat(LOGGER_RESULT_TYPE_URL, " for possible values"));
      }

      var details = LoggingPayload._generatePayloadDetails(payloadCopy);

      return new LoggingPayload(payloadCopy, details);
    }
  }, {
    key: "_generatePayloadDetails",
    value: function _generatePayloadDetails(payload) {
      var error = LoggingUtil.get(payload, 'error', undefined);

      if (error && error instanceof Error) {
        return {
          message: error.message,
          stackTrace: JSON.stringify(error.stack)
        };
      }

      return undefined;
    }
  }]);

  return LoggingPayload;
}();

export { LoggingPayload as default };